import React, { useContext } from 'react';
import sanitizeHtml from 'sanitize-html-react';

import { H2, H4, P1 } from '@zooplus/ui-components';

import LocResourcesContext from '../../../common/contexts/LocResourcesContext';
import ausImage from '../../assets/img/AUS@2x.jpg';
import ausImageBigger from '../../assets/img/AUS@2x.jpg';
import rafImage from '../../assets/img/Refer.jpg';
import rafImageBigger from '../../assets/img/Refer@2x.jpg';
import spImage from '../../assets/img/SP.jpg';
import spImageBigger from '../../assets/img/SP@2x.jpg';

const LoyaltyPrograms = ({}): JSX.Element => {
  const GLOBAL_PREFIX: string = 'loy-bp-shutdown';
  const { onFormatLocale } = useContext(LocResourcesContext);
  return (
    <>
      <H2 style={{ marginTop: '40px' }}>{onFormatLocale?.('loy.bp.shutdown.programs.title')}</H2>
      <div className={`${GLOBAL_PREFIX}-loyalty-programs`}>
        <div className={`${GLOBAL_PREFIX}-loyalty-programs--program`}>
          <picture>
            <source srcSet={ausImageBigger} media="(min-width: 545px)" />
            <img
              src={ausImage}
              alt="Imagen"
              className={`${GLOBAL_PREFIX}-loyalty-programs__image`}
            />
          </picture>
          <H4>{onFormatLocale?.('loy.bp.shutdown.programs.autoshipment.title')}</H4>
          <p>{onFormatLocale?.('loy.bp.shutdown.programs.autoshipment.description')}</p>
          <P1
            bold
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(onFormatLocale!('loy.bp.shutdown.programs.autoshipment.link')),
            }}
          />
        </div>
        <div className={`${GLOBAL_PREFIX}-loyalty-programs--program`}>
          <picture>
            <source srcSet={spImageBigger} media="(min-width: 545px)" />
            <img
              src={spImage}
              alt="Imagen"
              className={`${GLOBAL_PREFIX}-loyalty-programs__image`}
            />
          </picture>
          <H4>{onFormatLocale?.('loy.bp.shutdown.programs.sp.title')}</H4>
          <p>{onFormatLocale?.('loy.bp.shutdown.programs.sp.description')}</p>
          <P1
            bold
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(onFormatLocale!('loy.bp.shutdown.programs.sp.link')),
            }}
          />
        </div>
        <div className={`${GLOBAL_PREFIX}-loyalty-programs--program`}>
          <picture>
            <source srcSet={rafImageBigger} media="(min-width: 545px)" />
            <img
              src={rafImage}
              alt="Imagen"
              className={`${GLOBAL_PREFIX}-loyalty-programs__image`}
            />
          </picture>
          <H4>{onFormatLocale?.('loy.bp.shutdown.programs.raf.title')}</H4>
          <p>{onFormatLocale?.('loy.bp.shutdown.programs.raf.description')}</p>
          <P1
            bold
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(onFormatLocale!('loy.bp.shutdown.programs.raf.link')),
            }}
          />
        </div>
      </div>
    </>
  );
};

export default LoyaltyPrograms;
